/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

function clusterNodeFactory(UpdatableItem) {
    /**
     * @constructor
     * @memberOf module:avi/app
     * @extends module:avi/dataModel.UpdatableItem
     * @author Ram Pal
     * @desc ClusterNode item.
     */
    class ClusterNode extends UpdatableItem {
        /** @override */
        getIdFromData_(data) {
            return data && data.config && data.config.name || '';
        }
    }

    return ClusterNode;
}

clusterNodeFactory.$inject = [
    'UpdatableItem',
];

angular.module('avi/app')
    .factory('ClusterNode', clusterNodeFactory);
